<template>
  <div class="flex-column pb-2 align-items-start pr-4">
    <div class="d-flex flex-column">
      <h6 class="mb-0" :for="uuid" v-html="labelHtml" />
      <small class="pl-2" v-if="nb_caracteres && rows">{{ modelValue.replace(/(\r\n\t?|\n|\r\t)/gm, "")?.length ?? 0 }}/{{ nb_caracteres * rows }} - {{ rows }} lignes de <span :id="'nbcarligne'+uuid">{{ nb_caracteres }}</span> caractères</small>
      <small class="pl-2" v-else-if="nb_caracteres">{{ modelValue?.length ?? 0 }}/{{ nb_caracteres }}</small>
    </div>
      <textarea
          :value="modelValue"
          :rows="rows"
          :cols="cols"
          :id="uuid"
          class="p-2"
          @change="update($event.target.value)"
          @input="update($event.target.value)"
      ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      required: true,
      type: [String, Number]
    },
    required: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
    },
    cols: {
      type: Number,
      default: 25,
    },
    nb_caracteres: {
      type: Number
    },
    label: {
      type: String,
      default: " "
    },
    config: {
      type: Object,
      default: () => ({ type: "text" }),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  computed: {
    labelHtml() {
      return this.label;
    },
  },
  methods: {
    update(value) {
      this.$emit("update:modelValue", value); 
      this.istexttoolong(value);
    },
    istexttoolong(value) {
      const limiteMax = this.rows ? this.nb_caracteres * this.rows : this.nb_caracteres;
      if (value.replace(/(\r\n\t?|\n|\r\t)/gm, "").length > limiteMax) {
        document.querySelector("textarea[id='" + this.uuid + "']").classList.add("toolong");
        return;
      }
      if (value.replace(/(\r\n\t?|\n|\r\t)/gm, "").length <= limiteMax) {
        document.querySelector("textarea[id='" + this.uuid + "']").classList.remove("toolong");
      }
      const lignes = value.split("\n");
      console.log(lignes);
      for (let i = 0; i < lignes.length; i++) {
        const ligne = lignes[i];
        console.log("#nbcarligne" + this.uuid);
        if (ligne.length > this.nb_caracteres) {
          document.querySelector("textarea[id='" + this.uuid + "']").classList.add("toolong");
          document.querySelector("#nbcarligne" + this.uuid).classList.add("toolong");
          break;
        }        
        if (ligne.length <= this.nb_caracteres) {
          document.querySelector("textarea[id='" + this.uuid + "']").classList.remove("toolong");
          document.querySelector("#nbcarligne" + this.uuid).classList.remove("toolong");
        }
      }
    }
  },
};
</script>

<style scoped>
.toolong {
  color: red;
}
</style>